// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Dd_1I","col":"CardReaderDesc_col__2wcgR","label":"CardReaderDesc_label__Nbidx"};